<template>
  <b-row class="beneficial-owners-uppercase">
    <b-col cols="12" v-if="data && data.length > 0">
      <b-row class="mx-1 py-1" v-for="(person, idx) in data" :key="idx">
        <b-col cols="12">
          <b-row class="py-1 border-b border-gray align-items-center">
            <b-col>
              <span class="text-xs font-bold">
                {{ person.givenName }} {{  person.middleName }} {{ person.surname || person.surName }}
              </span>
            </b-col>
            <b-col v-if="person.parentBrn">
              <span class="text-xs font-bold mr-2">Parent:</span>
              <span class="text-xs font-bold mr-2">{{ person.parentBrn }}</span>
              <span class="text-xs font-bold">{{ person.parentName }}</span>
            </b-col>
            <b-col>
              <button class="bg-blue text-white rounded-sm px-2 py-1 text-xs float-end" @click="show(idx)">
                <span v-if="selectedIdx === idx">Hide Details</span>
                <span v-else>Show Details</span>
              </button>
            </b-col>
          </b-row>
          <b-row v-if="showDetails && selectedIdx === idx">
            <b-col cols="12" class="mt-2">
              <b-row>
                <b-col cols="4">
                  <b-form-group
                    class="text-sm my-1"
                    id="input-group-1"
                    label="Given Name"
                    label-for="input-1">
                    <b-form-input
                      class="form-text text-sm noFocus"
                      type="text"
                      disabled="true"
                      :value="person.givenName"
                      required>
                    </b-form-input>
                  </b-form-group>
                  <b-form-group
                    v-if="person.middleNames || person.middleName"
                    class="text-sm my-1"
                    id="input-group-1"
                    label="Middle Name"
                    label-for="input-1">
                    <b-form-input
                      class="form-text text-sm noFocus"
                      type="text"
                      disabled="true"
                      :value="person.middleNames || person.middleName"
                      required>
                    </b-form-input>
                  </b-form-group>
                  <b-form-group
                    class="text-sm my-1"
                    id="input-group-1"
                    label="Surname"
                    label-for="input-1">
                    <b-form-input
                      class="form-text text-sm noFocus"
                      type="text"
                      disabled="true"
                      :value="person.surname || person.surName"
                      required>
                    </b-form-input>
                  </b-form-group>
                  <b-form-group
                    v-if="person.idType"
                    class="text-sm my-1"
                    id="input-group-1"
                    label="ID Type"
                    label-for="input-1">
                    <b-form-input
                      class="form-text text-sm noFocus text-capitalize"
                      type="text"
                      disabled="true"
                      :value="getIdTypeLabel(person.idType).toLowerCase()"
                      required>
                    </b-form-input>
                  </b-form-group>
                  <b-form-group
                    class="text-sm my-1"
                    id="input-group-1"
                    label="ID Number"
                    label-for="input-1">
                    <b-form-input
                      class="form-text text-sm noFocus"
                      type="text"
                      disabled="true"
                      :value="person.idNumber || '–'"
                      required>
                    </b-form-input>
                  </b-form-group>
                  <b-form-group
                    class="text-sm my-1"
                    id="input-group-1"
                    label="Nationality"
                    label-for="input-1">
                    <b-form-input
                      class="form-text text-sm noFocus"
                      type="text"
                      disabled="true"
                      :value="person.nationality"
                      required>
                    </b-form-input>
                  </b-form-group>
                </b-col>
                <b-col cols="4">
                  <b-form-group
                    class="text-sm my-1"
                    id="input-group-1"
                    label="Email Address"
                    label-for="input-1">
                    <b-form-input
                      class="form-text text-sm noFocus"
                      type="text"
                      disabled="true"
                      :value="person.email || '–'"
                      required>
                    </b-form-input>
                  </b-form-group>
                  <b-form-group
                    class="text-sm my-1"
                    id="input-group-1"
                    label="Phone Number"
                    label-for="input-1">
                    <b-form-input
                      class="form-text text-sm noFocus"
                      type="text"
                      disabled="true"
                      :value="person.phone || person.phoneNumber || '–'"
                      required>
                    </b-form-input>
                  </b-form-group>
                  <b-form-group
                    v-if="person.gender || person.sex"
                    class="text-sm my-1"
                    id="input-group-1"
                    label="Gender (at birth)"
                    label-for="input-1">
                    <b-form-input
                      class="form-text text-sm noFocus text-capitalize"
                      type="text"
                      disabled="true"
                      :value="(person.gender || person.sex).toLowerCase()"
                      required>
                    </b-form-input>
                  </b-form-group>
                  <b-form-group
                    class="text-sm my-1"
                    id="input-group-1"
                    label="Date of Birth"
                    label-for="input-1">
                    <b-form-input
                      class="form-text text-sm noFocus"
                      type="text"
                      disabled="true"
                      :value="formatDate(person.dateOfBirth)"
                      required>
                    </b-form-input>
                  </b-form-group>
                  <b-form-group
                    class="text-sm my-1"
                    id="input-group-1"
                    label="Occupation"
                    label-for="input-1">
                    <b-form-input
                      class="form-text text-sm noFocus"
                      type="text"
                      disabled="true"
                      :value="person.occupation"
                      required>
                    </b-form-input>
                  </b-form-group>
                </b-col>
                <b-col cols="4">
                  <div v-if="person.address">
                    <AdminUnitsView :data="person.address" :api="api" />
                  </div>
                  
                  <b-form-group
                    v-if="person.percentageShares"
                    class="text-sm my-1"
                    id="input-group-1"
                    label="Percentage Shares"
                    label-for="input-1">
                    <b-form-input
                      class="form-text text-sm noFocus"
                      type="text"
                      disabled="true"
                      :value="person.percentageShares"
                      required>
                    </b-form-input>
                  </b-form-group>
                  <b-form-group
                    v-if="person.percentageVotingRights"
                    class="text-sm my-1"
                    id="input-group-1"
                    label="Percentage Voting Rights"
                    label-for="input-1">
                    <b-form-input
                      class="form-text text-sm noFocus"
                      type="text"
                      disabled="true"
                      :value="person.percentageVotingRights"
                      required>
                    </b-form-input>
                  </b-form-group>
                  <b-form-group
                    v-if="person.hasVotingRights !== undefined"
                    class="text-sm my-1"
                    id="input-group-1"
                    label="Has Voting Rights"
                    label-for="input-1">
                    <b-form-input
                      class="form-text text-sm noFocus"
                      type="text"
                      disabled="true"
                      :value="person.hasVotingRights"
                      required>
                    </b-form-input>
                  </b-form-group>
                  <b-form-group
                    v-if="person.hasRightToAppoint !== undefined"
                    class="text-sm my-1"
                    id="input-group-1"
                    label="Has Right To Appoint"
                    label-for="input-1">
                    <b-form-input
                      class="form-text text-sm noFocus"
                      type="text"
                      disabled="true"
                      :value="person.hasRightToAppoint"
                      required>
                    </b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-col>
    <b-col cols="12" v-else>
      <div class="text-center py-8 text-gray-500 text-sm">
        <i class="fa fa-user-tie text-3xl mb-2"></i>
        <p>No beneficial owners information available</p>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import moment from "moment";
import AdminUnitsView from './AdminUnitsView.vue';

export default {
  name: 'BeneficialOwnersView',
  components: { AdminUnitsView },
  props: {
    data: {
      type: Array,
      default: function () { return []; },
    },
    cardinality: {
      type: String,
      default: '',
    },
    api: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      showDetails: false,
      selectedIdx: null,
    };
  },
  methods: {
    show(idx) {
      if (this.selectedIdx === idx) {
        this.selectedIdx = null;
        this.showDetails = false;
      } else {
        this.selectedIdx = idx;
        this.showDetails = true;
      }
    },
    getIdTypeLabel(idType) {
      if (!idType) return '–';
      var labels = {
        national_id: 'National ID',
        passport: 'Passport',
        driving_permit: 'Driving Permit',
        refugee_id: 'Refugee ID',
        voter_id: 'Voter ID',
      };
      return labels[idType] || idType || '–';
    },
    formatDate(dateString) {
      if (dateString) {
        return moment(dateString).format("DD/MM/YYYY");
      }
      return "–";
    },
  },
};
</script>

<style scoped>
.beneficial-owners-uppercase {
  text-transform: uppercase;
}

</style>
